import translationApi from '../../api/translation.api';

// initial state
const state = {
  translations: {},
  translationsStatus: '',
};

// getters
const getters = {
  translations: state => state.translations,
  translationsStatus: state => state.translationsStatus,
};

// actions
const actions = {
  getAdminTranslations({ commit }, payload) {
    return translationApi.getAdminTranslations(payload)
      .then((response) => {
        commit('TRANSLATIONS', response.translations);
      });
  },

  updateAdminTranslationsByKey({ commit }, payload) {
    return translationApi.updateAdminTranslationsByKey(payload)
      .then((response) => {
        commit('TRANSLATIONS', response.translations);
      });
  },

  addAdminTranslationsLanguage({ commit }, payload) {
    return translationApi.addAdminTranslationsLanguage(payload)
      .then((response) => {
        commit('TRANSLATIONS', response.translations);
      });
  },
};

// mutations
const mutations = {
  TRANSLATIONS(state, translations) {
    state.translations = translations;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
